import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAuthStore } from '@/lib/auth-store';
import { toast } from 'sonner';
import { LogIn } from 'lucide-react';
import { api } from '@/lib/api-client';
import type { User } from '@shared/types';
interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function LoginModal({ isOpen, onClose }: LoginModalProps) {
  const loginAction = useAuthStore((s) => s.login);
  const [email, setEmail] = useState('admin@email.stv.vn');
  const [password, setPassword] = useState('admin123');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await api<{ token: string; user: User }>('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password })
      });
      loginAction(response.user, response.token);
      toast.success('Chào mừng quay trở lại!');
      onClose();
    } catch (error: any) {
      toast.error(error.message || 'Đăng nhập thất bại. Vui lòng kiểm tra lại.');
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Dialog open={isOpen} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-[425px] glass-card border-white/10">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold flex items-center gap-2">
            <LogIn className="h-5 w-5 text-primary" />
            Đăng nhập Quản trị
          </DialogTitle>
          <DialogDescription className="text-muted-foreground">
            Truy cập bảng điều khiển và quản lý tất cả các hộp thư tạm thời của bạn.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-6 py-4">
          <div className="space-y-2">
            <Label htmlFor="email">Địa chỉ email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-white/5 border-white/10"
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Mật khẩu</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-white/5 border-white/10"
              required
            />
          </div>
          <div className="bg-primary/10 p-3 rounded-lg border border-primary/20">
            <p className="text-xs text-primary-foreground/70 leading-relaxed">
              <strong>Tài khoản Demo:</strong><br />
              Email: admin@email.stv.vn<br />
              Mật khẩu: admin123
            </p>
          </div>
          <DialogFooter>
            <Button type="submit" className="w-full btn-purple" disabled={isLoading}>
              {isLoading ? 'Đang xác thực...' : 'Đăng nhập'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
